// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Perkelta ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => p['label'] + ' veiksmas atliktas',
  accButtonProgressStatus: (p: { label: string }) => p['label'] + ' veiksmas vykdomas',
  accColorPalette: () => 'Spalvų paletė',
  accColorSwatch: () => 'Spalvos pavyzdėlis',
  accCommandKey: () => 'Komanda',
  accContextMenuLabel: () => 'veiksmai',
  accControlKey: () => 'Uždaryti',
  accPositionAfter: () => 'po',
  accPositionBefore: () => 'prieš',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Laikydami paspaudę ' +
    p['keyPressed'] +
    ' ir SHIFT klavišus naudokite rodyklės klavišus, kad pakeistumėte tvarką.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Įveskite įvykdymo datą taip: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Įveskite mėnesį ir metus taip: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Žyma',
  chart_labelGroup: () => 'Grupė',
  chart_labelSeries: () => 'Serija',
  chart_labelValue: () => 'Reikšmė',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Pasirinkite reikšmę.',
  checkbox_helpForCheckbox: () => 'Žymės langelio žinynas',
  checkbox_requiredMessageDetail: () => 'Pasirinkite reikšmę.',
  checkbox_selected: () => 'Žymės langelis pažymėtas',
  checkbox_unselected: () => 'Žymės langelis nepažymėtas',
  close: () => 'Uždaryti',
  collection_apply: () => 'Taikyti',
  collection_cancel: () => 'Atšaukti',
  collection_loaded: () => 'Įkelta',
  collection_loading: () => 'Įkeliama',
  collection_noData: () => 'Nėra rodytinų duomenų.',
  collection_pixels: () => 'piks.',
  collection_resizeColumnDialog: () => 'Keisti stulpelio dydį',
  collection_resizeColumnMenu: () => 'Keisti stulpelio dydį...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Įveskite skaičių nuo ' + p['MIN'] + ' iki ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Pasirinkti visas eilutes',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Pasirinkti eilutę ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Didėjimo tvarka',
  collection_sortColumnMenu: () => 'Rikiavimo stulpelis',
  collection_sortDescendingSubMenu: () => 'Mažėjimo tvarka',
  collection_sortDisabled: () => 'Nerikiuojama',
  collection_sortEnabled: () => 'Rikiuojama',
  collection_width: () => 'Plotis',
  colorPicker_label: () => 'Spalvų parinkiklis',
  confirmation: () => 'Patvirtinimas',
  datePicker_currentDate: () => 'Dabartinė data',
  datePicker_goToToday: () => 'Eiti į šiandien',
  datePicker_label: () => 'Datos parinkiklis',
  datePicker_month: () => 'Mėnuo',
  datePicker_months: () => 'Mėnesiai',
  datePicker_next: () => 'Kitas',
  datePicker_nextDecade: () => 'Kitas dešimtmetis',
  datePicker_nextMonth: () => 'Kitas mėnuo',
  datePicker_prev: () => 'Ankstesnis',
  datePicker_prevDecade: () => 'Ankstesnis dešimtmetis',
  datePicker_prevMonth: () => 'Ankstesnis mėnuo',
  datePicker_restricted: () => 'Apribota',
  datePicker_selected: () => 'Pasirinkta',
  datePicker_today: () => 'Šiandien',
  datePicker_weekNum: (p: { NUM: string }) => p['NUM'] + ' savaitė',
  datePicker_weekNumColLabel: () => 'Savaitės numeris',
  datePicker_year: () => 'Metai',
  datePicker_years: () => 'Metai',
  diagram_promotedLink: () => '1 saitas',
  diagram_promotedLinkAriaDesc: () => 'Netiesioginis',
  diagram_promotedLinks: (p: { num_links: string }) => 'Saitų: ' + p['num_links'],
  error: () => 'Klaida',
  expandableList_expandCollapseInstructionText: () =>
    'Naudokite rodyklių klavišus norėdami išskleisti ir sutraukti',
  expandableList_groupCollapse: () => 'Sutraukta',
  expandableList_groupExpand: () => 'Išskleista',
  filePicker_addFiles: () => 'Įtraukti failų',
  filePicker_dropzonePrimaryText: () => 'Nuvilkimas',
  filePicker_dropzoneSecondaryText: () => 'Pasirinkite failą arba jį nuvilkite čia',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Pasirinkite arba nuvilkite failus čia',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Šio tipo failų įkelti negalima: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Vienu kartu galima įkelti vieną failą',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    p['fileType'] + ' tipo failų įkelti negalima',
  filePicker_unknownFileTypeUploadError: () => 'nežinoma',
  formControl_clear: () => 'Valyti',
  formControl_day: () => 'Diena',
  formControl_empty_segment: () => 'Tuščia',
  formControl_helpAvailable: () => 'Žinynas pasiekiamas',
  formControl_hide: () => 'Slėpti',
  formControl_hour: () => 'Valanda',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Pasiekėte ribą  ' +
    ((
      {
        one: new Intl.NumberFormat('lt').format(p['CHARACTER_LIMIT']) + '-character',
        few: new Intl.NumberFormat('lt').format(p['CHARACTER_LIMIT']) + '-character',
        many: new Intl.NumberFormat('lt').format(p['CHARACTER_LIMIT']) + '-character'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('lt').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('lt').format(p['CHARACTER_LIMIT']) + '-character') +
    '.',
  formControl_loading: () => 'Įkeliama',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Galite įvesti iki ' + p['MAX_LENGTH'] + ' simbolių.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Viršytas maksimalus ilgis ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' simboliai (-ių) liko.',
  formControl_millisecond: () => 'Milisekundė',
  formControl_minute: () => 'Minutė',
  formControl_month: () => 'Mėnuo',
  formControl_readOnly: () => 'Tik skaityti',
  formControl_requiredMessageDetail: () => 'Įveskite reikšmę.',
  formControl_second: () => 'Sekundė',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Pasirinkite ' + p['n'] + ' reikšmes (-ių).',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Pasiekėte ' + p['max'] + '-pasirinkimo ribą.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Pasirinkite reikšmes nuo ' + p['min'] + ' iki ' + p['max'] + '.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Pasirinkite mažiausiai ' + p['min'] + ' reikšmes (-ių).',
  formControl_show: () => 'Rodyti',
  formControl_year: () => 'Metai',
  gantt_labelDate: () => 'Data',
  gantt_labelEnd: () => 'Baigti',
  gantt_labelLabel: () => 'Žyma',
  gantt_labelRow: () => 'Eilutė',
  gantt_labelStart: () => 'Pradėti',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nerasta jokių atitinkančių skyrių.',
  indexer_keyboardInstructionText: () => 'Norėdami pasirinkti reikšmę, paspauskite Enter.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Tarp ' + p['FROM_SECTION'] + '  ir ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Du kartus spustelėkite ir palaikykite, kad įjungtumėte gestų režimą, tada vilkite aukštyn arba žemyn, kad koreguotumėte reikšmę.',
  info: () => 'Informacija',
  inputColor_selectColor: () => 'Pasirinkite spalvą',
  inputDateMask_date_cleared: () => 'Data išvalyta',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tuščia',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'mmmm',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Įveskite ' + p['max'] + ' arba ankstesnę datą.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Įveskite ' + p['min'] + ' arba vėlesnę datą.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Įveskite galimą datą.',
  inputDatePicker_instruction: () => 'Paspauskite Tab, kad pasiektumėte kalendorių.',
  inputDatePicker_selectDate: () => 'Pasirinkite datą',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Įveskite mėnesį ir metus, kurie sutaptų su ' + p['max'] + ' arba būtų ankstesni.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Įveskite mėnesį ir metus, kurie sutaptų su ' + p['min'] + ' arba būtų vėlesni.',
  inputNumber_converterParseError: () => 'Įveskite skaičių.',
  inputNumber_decrease: () => 'Sumažinti',
  inputNumber_increase: () => 'Padidinti',
  inputPassword_hidden: () => 'Slaptažodis paslėptas',
  inputPassword_hide: () => 'Slėpti slaptažodį',
  inputPassword_show: () => 'Rodyti slaptažodį',
  inputSensitiveText_hidden: () => 'Slaptas tekstas paslėptas',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Įveskite ' + p['max'] + ' arba ankstesnį laiką.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Įveskite ' + p['min'] + ' arba vėlesnį laiką.',
  inputTimeMask_time_cleared: () => 'Išvalymo laikas',
  labelNone: () => 'Nėra',
  list_msgFetchCompleted: () => 'Įkelta',
  list_msgFetchingData: () => 'Įkeliama',
  list_suggestion: () => 'Pasiūlymas',
  menu_stateLoading: () => 'Įkeliama',
  messageToast_allMessagesClosed: () => 'Visi informaciniai pranešimai uždaryti.',
  message_close: () => 'Uždaryti',
  message_confirmation: () => 'Pavyko',
  message_error: () => 'Klaida',
  message_info: () => 'Informacija',
  message_navigationFromMessagesRegion: () =>
    'Įeinama į pranešimų sritį. Norėdami naršyti, paspauskite F6.',
  message_navigationToMessagesRegion: () =>
    'Pranešimų srityje yra naujų pranešimų. Paspauskite F6 norėdami naršyti.',
  message_navigationToTouch: () => 'Pranešimų srityje yra naujų pranešimų.',
  message_warning: () => 'Perspėjimas',
  noData_message: () => 'Nėra rodytinų elementų',
  overflowItemLabel: () => 'Daugiau skirtukų',
  plural_separator: () => ', ',
  popup_close_skipLink: () =>
    'Bakstelėkite du kartus, kad uždarytumėte atidarytą iššokantįjį pranešimą.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Įeinama į iššokančiųjų pranešimų sritį. Paspauskite F6, kad naršytumėte tarp iššokančiojo pranešimo ir susijusio valdiklio.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Atidarytas iššokantysis pranešimas. Paspauskite F6, kad naršytumėte tarp iššokančiojo pranešimo ir susijusio valdiklio.',
  progressIndeterminate: () => 'Vykdoma',
  radioButton_checked: () => 'Pasirinkimo mygtukas pažymėtas',
  radioButton_selected: () => 'Pasirinkimo mygtukas pasirinktas',
  radioButton_unchecked: () => 'Pasirinkimo mygtukas nepažymėtas',
  radioButton_unselected: () => 'Pasirinkimo mygtukas nepasirinktas',
  radio_helpForRadio: () => 'Išrinkimo mygtuko žinynas',
  radio_requiredMessageDetail: () => 'Pasirinkite reikšmę.',
  selectMultiple_apply: () => 'Taikyti',
  selectMultiple_back: () => 'Atgal',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Naudokite rodyklių kairėn ir dešinėn klavišus, kad pažymėtumėte pasirinktas reikšmes.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Paspauskite Grįžti arba Naikinti, kad pašalintumėte pasirinktą reikšmę.',
  selectMultiple_selectedValues: () => 'Parinktos reikšmės',
  selectMultiple_showSelectedValues: () => 'Rodyti tik pasirinktas reikšmes.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Pasirinkta reikšmių: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Įtraukti į sąrašą',
  select_addToListAvailable: () => 'Įtraukimas į sąrašą prieinamas',
  select_closeDropdown: () => 'Paspauskite Escape norėdami uždaryti.',
  select_moreSearchOptions: () => 'Daugiau paieškos parinkčių',
  select_moreSearchOptionsAvailable: () => 'Daugiau ieškos parinkčių prieinama',
  select_noMatchesFound: () => 'Atitikmenų nerasta.',
  select_oneMatchFound: () => 'Rastas vienas atitikmuo',
  select_requiredMessageDetail: () => 'Pasirinkite reikšmę.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Rasta ' + p['TOTAL_SIZE'] + ' atitikmenų',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Rasta ' + p['TOTAL_SIZE'] + ' arba daugiau atitikmenų',
  selectorAll_deselectAll: () => 'Atžymėti viską',
  selectorAll_selectAll: () => 'Pasirinkti viską',
  selector_selected: () => 'Žymės langelis pažymėtas',
  selector_unselected: () => 'Žymės langelis nepažymėtas',
  sheet_close: () => 'Uždaryti',
  switch_off: () => 'Išj.',
  switch_on: () => 'Įjungta',
  tabBarNavigationList_removeCueText: () => 'Pašalinama',
  tabBar_tabContainsErrors: () => 'Yra klaidų',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Pašalinta ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'turi kontekstinį meniu',
  tabbar_labelMoveLeft: () => 'Perkelti kairėn',
  tabbar_labelMoveRight: () => 'Perkelti dešinėn',
  tabbar_labelRemove: () => 'Pašalinti',
  timeComponent_tooltipZoomIn: () => 'Artinti',
  timeComponent_tooltipZoomOut: () => 'Tolinti',
  timeConverter_parseError: () => 'Įveskite įvykdymo laiką.',
  train_current: () => 'Dabartinis',
  train_message_type: () => 'Pranešimo tipas',
  train_not_visited: () => 'Neaplankyta',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    p['currentStep'] + ' žingsnis iš ' + p['numberOfSteps'],
  train_visited: () => 'Aplankyta',
  userAssistance_learnMore: () => 'Sužinokite daugiau',
  userAssistance_required: () => 'Būtina',
  vis_clearSelection: () => 'Išvalyti pasirinktą sritį',
  vis_drillable: () => 'Kilmė analizuojama',
  vis_invalidData: () => 'Neleistini duomenys',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' iš ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Nuosvyros pasirinkimas',
  vis_marqueeZoomTooltip: () => 'Nuosvyros mastelio keitimas',
  vis_noData: () => 'Nėra rodytinų duomenų',
  vis_panTooltip: () => 'Slinkti',
  vis_stateCollapsed: () => 'Sutraukta',
  vis_stateExpanded: () => 'Išskleista',
  vis_stateLoaded: () => 'Įkelta',
  vis_stateLoading: () => 'Įkeliama',
  vis_stateSelected: () => 'Pasirinkta',
  vis_stateUnselected: () => 'Nepasirinkta',
  warn: () => 'Perspėjimas'
};
export default bundle;
